export default __webpack_public_path__ + "static/slide-3-2cfc5dba563f4c3f97b529810cfa6a40.png";